import { Component, Input } from '@angular/core';
import { ImageMetadata } from "../../../_objects/image-metadata";

@Component({
    selector: 'app-image-metadata-card',
    templateUrl: './image-metadata-card.component.html',
    styleUrl: './image-metadata-card.component.scss',
    standalone: false
})
export class ImageMetadataCardComponent {

  @Input() imageMetadata: ImageMetadata;
  @Input() properties: {key: string, value: string}[];

}
